<template>
    <div class="container">
        <div class="form-new-Batch"> 
            <h3 class="title"> {{$t('new_batch')}} </h3>
            <div class= "newBatch-container" v-show="modalStyle == 'UNITY'">
                <section id= "firstSection">
                    <label for="new-batch-agrup-unity">{{$t('unit_grouping')}}:</label>
                    <div class="select-container">
                        <v-select
                            class="batch-select-autocomplete"
                            :multiple="true"
                            :disabled="view.batchData.checkedAgrupFili"
                            :options="view.batchData.agrupFili"
                            :getOptionLabel="o => `${o.CDGRUPFILI} | ${o.NMGRUPFILI}`"
                            :clearable="false" 
                            v-model="view.batchData.selectedAgrupFili"
                            @input="getFiliOper"
                        ></v-select>
                        <div class="input-container">
                            <input 
                                class="allCheck"
                                type="checkbox"
                                id="scales"
                                name="scales"
                                :checked="view.batchData.checkedAgrupFili"
                                @click="allAgrupFiliClicked" 
                            />
                            <span>{{$t('all')}}</span>
                        </div>
                    </div>
                    <label for="batch-unity">{{$t('unit')}}:</label>
                    <div class="select-container">
                        <v-select
                            class="batch-select-autocomplete"
                            :multiple="true"
                            :disabled="view.batchData.checkedFilial"
                            :options="view.batchData.filial"
                            :getOptionLabel="o => `${o.CDFILIAL} | ${o.NMFILIAL}`"
                            :clearable="false" 
                            v-model="view.batchData.selectedFilial"
                            @input="getService"
                        ></v-select>
                        <div class="input-container">
                            <input 
                                class="allCheck"
                                type="checkbox"
                                id="scales"
                                name="scales"
                                :checked="view.batchData.checkedFilial"
                                @click="allFiliClicked" 
                            />
                            <span>{{$t('all')}}</span>
                        </div>
                    </div>
                    
                    <label for="batch-service">{{$t('service')}}:</label>
                    <div class="select-container">
                        <v-select
                            class="batch-select-autocomplete"
                            :multiple="true"
                            :disabled="view.batchData.checkedService == true"
                            :options="view.batchData.services"
                            :getOptionLabel="o => `${o.CDFILIAL} | ${o.CDSERVFILI} | ${o.NMSERVICO}`"
                            :clearable="false" 
                            v-model="view.batchData.selectedService"
                        ></v-select>
                        <div class="input-container">
                            <input 
                                class="allCheck"
                                type="checkbox"
                                id="scales"
                                name="scales"
                                :checked="view.batchData.checkedService"
                                @click="allServiceClicked" 
                            />
                            <span>{{$t('all')}}</span>
                        </div>
                    </div>
                    
                    <label for="month">{{$t('month')}}:</label>
                    <div class="date-field">
    					<input 
                            id="month" 
                            type="month"
                            v-model="view.batchData.selectedMonth"
                        />
    				</div>
    			</section>
				
    			<hr class="horizontal-separator">
    			
    			<section id="secondSection">
    				<label for="date">{{$t('reference_date')}}:</label>
                    <div class="date-field">
    					<input 
                            id="date" 
                            type="date"
                            v-model="view.batchData.selectedDateRef"
                        />
    				</div>
    				
    				<label for="batch-type-cost">{{$t('cost_type')}}:</label>
                    <div class="select-container">
                        <v-select
                            class="batch-select-autocomplete"
                            :multiple="false"
                            :options="view.batchData.typeCost"
                            :getOptionLabel="o => `${o.CDTIPOCUSTO} | ${o.NMTIPOCUSTO}`"
                            :clearable="false" 
                            v-model="view.batchData.selectedTypeCost"
                        ></v-select>
                    </div>
                
                    <label for="batch-type-cost">{{$t('group_products_cong_menu')}}:</label>
                    <div class="select-container dropdown-agrup-prod">
                        <v-select
                            class="batch-select-autocomplete"
                            :multiple="false"
                            :options="view.batchData.agrupProd"
                            :getOptionLabel="o => `${o.CDGRUPPROD} | ${o.NMGRUPPROD}`"
                            :clearable="true" 
                            v-model="view.batchData.selectedAgrupProd"
                        ></v-select>
                    </div>
                </section>
            </div>
            <div class="footer">
                <div class="footer-buttons">
                    <button class="button no-fill" @click="hideModal"> <i class="fas fa-times"></i> {{$t('cancel')}} </button> 
                    <button class="button fill" @click="saveNewBatch"> 
                        <span v-show="showLoad"> {{$t('save')}} </span> 
                        <img v-show="!showLoad" :src="view.batchData.loadGif" style="height: 33px; margin: auto;"/>
                    </button>
                </div>
                <div class="checkbox-alert">
                        <input 
                            class="allCheck"
                            type="checkbox"
                            id="scales"
                            name="scales"
                            :checked="view.batchData.checkedVerifyAlert"
                            @click="verifyAlertClick" 
                        />
                        <span style="padding-left: 5px">{{$t('check_service_alerts')}}</span>
                </div>
            </div>
        </div>
        <modal
            name="message" 
			:height="'auto'" 
			:clickToClose="false"
        >
            <message-pop-up 
                :modal="this.modal"
                :title="view.message.title"
                :message="view.message.message"
                :nameModal="'message'"
            />
        </modal>
    </div>
</template>

<script>
import vSelect from "vue-select";
import BatchOptimizationProvider from '@/application/providers/BatchOptimizationProvider'
import MessagePopUp from '@/components/src/MessagePopUp'
import moment from 'moment';
import Util from '@/application/libs/util';
import { t } from 'i18next'

export default {
    name: 'BatchForm',
    props: {
        modal: {
            type: Object
        },
        name: {
            type: String
        },
        modalStyle: {
            type: String,
            default: 'UNITY'
        },
        validity: {
            type: Object
        },
        showLoad: {
            type: Boolean,
            default: true
        },
        showAdd: {
            type: Boolean,
            default: true
        },
        showOverlap: {
            type: Boolean,
            default: true
        },
        showMultiGroup: {
            type: Boolean,
            default: false
        }
    },
    components: {
        "v-select": vSelect,
        "message-pop-up": MessagePopUp
    },
    data() {
        return {
            view: {
                batchData:{
                    mode: this.showAdd ? 'ACRESCENTAR' : 'SOBREPOR',
                    modeGroup: 'S',
                    agrupFili: [],
                    selectedAgrupFili: null,
                    filial: [],
                    selectedFilial: null,
                    services: [],
                    selectedService: null,
                    checkedAgrupFili: true,
                    checkedFilial: false,
                    checkedService: false,
                    checkedVerifyAlert: true,
                    selectedMonth: "",
                    typeCost: [],
                    selectedTypeCost: null,
                    agrupProd: [],
                    selectedAgrupProd: null,
                    selectedDateRef: moment().format('YYYY-MM-DD'),
                    loadGif: require("../../../static/loading_gif_export.gif")
                },
                message: {
                    title: '',
                    message: ''
                }
            }
        }
    },
    mounted() {
        this.resetObjectModal();
        const { DTMESCARD } = Util.getFilterInSession();
        if(this.modalStyle == 'UNITY') {
            this.getAgrupFili();
            this.getFiliOper();
            this.getService();
            this.getTypeCost();
            this.getAgrupProd();
            this.view.batchData.selectedMonth = moment(DTMESCARD, 'DD/MM/YYYY').format('YYYY-MM');
        }
    },
    methods: {
        getAgrupFili: function() {
			BatchOptimizationProvider.getAgrupFili().then((agrupFili) => {
				this.view.batchData.agrupFili = agrupFili;
			});
		},
        getFiliOper: function() {
            let listaAgrupFili = '';
            if(!this.view.batchData.checkedAgrupFili && Array.isArray(this.view.batchData.selectedAgrupFili)) {
                listaAgrupFili = this.view.batchData.selectedAgrupFili.map( agrupFili => agrupFili.CDGRUPFILI).join('_');
            }
            if(this.view.batchData.checkedAgrupFili) listaAgrupFili = 'T';

			BatchOptimizationProvider.getFiliOper(listaAgrupFili).then((filial) => {
				this.view.batchData.filial = filial;
                this.view.batchData.selectedFilial = null;
                this.view.batchData.selectedService = null;
                this.view.batchData.services = [];
                this.getService();
			});
		},
		getService: function() {
		    let listaAgrupFili = '';
			let listaFilial = '';
			if(!this.view.batchData.checkedAgrupFili && Array.isArray(this.view.batchData.selectedAgrupFili)) {
                listaAgrupFili = this.view.batchData.selectedAgrupFili.map( agrupFili => agrupFili.CDGRUPFILI).join('_');
            }
			if(!this.view.batchData.checkedFilial && Array.isArray(this.view.batchData.selectedFilial)) {
                listaFilial = this.view.batchData.selectedFilial.map( filial => filial.CDFILIAL).join('_');
            }
            if(this.view.batchData.checkedAgrupFili) listaAgrupFili = 'T';
            if(this.view.batchData.checkedFilial) listaFilial = 'T';
            BatchOptimizationProvider.getService(listaAgrupFili,listaFilial).then((services) => {
				this.view.batchData.services = services;
                this.view.batchData.selectedService = null;
			});
        },
        getTypeCost: function() {
            let batchData = this.view.batchData;
            BatchOptimizationProvider.getDefaultTypeCostPla().then( CDTIPOCUSTOPLA => {
                BatchOptimizationProvider.getTypeCost().then( typeCost => {
				    batchData.typeCost = typeCost;
                    if( CDTIPOCUSTOPLA ) {
                        let filteredCost = typeCost.find( cost => {
                            return cost.CDTIPOCUSTO === CDTIPOCUSTOPLA;
                        });
                        batchData.selectedTypeCost = filteredCost || null;
                    }
			    });
            });
        },
        getAgrupProd: function() {
            let batchData = this.view.batchData;
            BatchOptimizationProvider.getDefaultAgrupProd().then( CDGRUPPRODOTMCARD => {
                BatchOptimizationProvider.getAgrupProd().then( agrupProd => {
				    batchData.agrupProd = agrupProd;
                    if( CDGRUPPRODOTMCARD ) {
                        let agrup = agrupProd.find( agrup => {
                            return agrup.CDGRUPPROD === CDGRUPPRODOTMCARD;
                        });
                        batchData.selectedAgrupProd = agrup || null;
                    }
			    });
            });
        },
        resetObjectModal: function() {
            this.view.batchData.selectedAgrupFili = null;
			this.view.batchData.selectedFilial = null;
			this.view.batchData.selectedService = null;
			this.view.batchData.selectedTypeCost = null;
			this.view.batchData.selectedAgrupProd = null;
			this.view.batchData.services = [];
		},
        hideModal: function() {
            this.resetObjectModal();
            this.modal.hide('new-batch-modal');
        },
        verifyAlertClick: function(){
            this.view.batchData.checkedVerifyAlert = !this.view.batchData.checkedVerifyAlert;
        },
        allAgrupFiliClicked: function() {
			this.view.batchData.selectedAgrupFili = null;
			this.view.batchData.checkedAgrupFili = !this.view.batchData.checkedAgrupFili;
			this.getFiliOper();
        },
        allFiliClicked: function() {
			this.view.batchData.selectedFilial = null;
			this.view.batchData.checkedFilial = !this.view.batchData.checkedFilial;
			this.getService();
        },
        allServiceClicked: function() {
			this.view.batchData.selectedService = null;
			this.view.batchData.checkedService = !this.view.batchData.checkedService;
        },
        allMultiGroupClicked: function() {
            this.view.batchData.selectedGroupPrat = null;
			this.view.batchData.checkedMultGroup = !this.view.batchData.checkedMultGroup;
        },
        saveNewBatch: function() {
            if(this.isValidField()) {
                this.$emit('saveNewBatch', this.view);
            } else {
                this.showLoad = true;
            }
        },
        switchMode: function(newMode) {
          this.view.batchData.mode = newMode;
        },
        switchModeGroup: function(newModeGroup) {
            this.view.batchData.modeGroup = newModeGroup;
        },
        isValidField: function() {
            if(!this.view.batchData.checkedAgrupFili && this.view.batchData.selectedAgrupFili == null) {
                this.showMessage(t('invalid_data'), t('unselected_unit_grouping_field'));
                return false;
            } else if(!this.view.batchData.checkedFilial && this.view.batchData.selectedFilial == null) {
                this.showMessage(t('invalid_data'), t('unit_field_not_selected'));
                return false;
            } else if(!this.view.batchData.checkedService && this.view.batchData.selectedService == null) {
                this.showMessage(t('invalid_data'), t('service_field_not_selected'));
                return false;
            } else if(!this.view.batchData.selectedMonth){
                this.showMessage(t('invalid_data'), t('month_field_not_selected'));
                return false;
            }

            return true;
        },
        showMessage: function(title, message) {
            this.view.message.title = title;
            this.view.message.message = message;
            this.$forceUpdate();
            this.modal.show('message');
        }
    }
}
</script>

<style lang="less">
	div[data-modal="new-batch-modal"] {
		overflow-y: hidden;
	}
	div[data-modal="new-batch-modal"] .v--modal-box.v--modal{
		overflow: visible;
		display: flex;
        flex-direction: column;
	}
    .batch-select-autocomplete > .vs__dropdown-menu {
        max-height: 40vh;
    }
    #secondSection .batch-select-autocomplete > .vs__dropdown-menu {
        max-height: 20vh;
    }
    #secondSection .dropdown-agrup-prod > .batch-select-autocomplete > .vs__dropdown-menu{
        max-height: 15vh;
    }
</style>
<style lang="less" scoped>
    .form-new-Batch {
        width: calc(100% - 30px);
		margin-bottom: 30px;

        .title {
		    margin: 20px 40px 15px 40px;
        }

        .newBatch-container {
			display: inline-block;
			margin: 0px;
			text-align: left;
			font-size: .9rem;
			width: calc(100% - 45px);
        }
        
        .select-container {
            display: grid;
            grid-template-columns: 80% 20%;
            margin: auto auto 10px auto;
            .input-container {
                margin: auto auto 5px auto;
                input, span {
                    vertical-align: middle;
                    display: inline-block;
                }
            }
        }

        .mode-switch {
            margin-top: 10px;
            font-size: .9rem;
            border-radius: 5px;
            width: fit-content;
            color: #DC143D;
            border: 1px solid #DC143D;
            cursor: pointer;
            user-select: none;
            width: 100%;
            display: flex;

            .mode-switch-option{
                flex: 1;
                text-align: center;
                border-radius: 5px;
                padding: 7px;
                transition: .3s background-color;
                &:hover{
                    background-color: #fcdee4;
                }

                &.active{
                    background-color: #DC143D;
                    color: white;
                }
            }
        }

        .allCheck {
            position: relative;
            cursor: pointer;
            height: 20px;
            width: 20px;
        }
        
        .allCheck:before {
            content: "";
            display: block;
            position: absolute;
            width: 20px;
            height: 20px;
            top: -1px;
            left: -1px;
            background-color: white;
            border: 2px solid #dc143d;
            border-radius: 5px;
        }

        .allCheck:checked:before {
            content: "";
            display: block;
            position: absolute;
            margin: auto;
            width: 20px;
            height: 20px;
            top: -2px;
            left: -1px;
            background-color: #dc143d;
            border: 2px solid #dc143d;
            border-radius: 5px;
        }

        .allCheck:checked:after {
            content: "";
            display: block;
            width: 5px;
            height: 10px;
            border: solid white;
            border-width: 0 2px 2px 0;
            -webkit-transform: rotate(45deg);
            transform: rotate(45deg);
            position: absolute;
            top: 3px;
            left: 8px;
        }

        .button{
            min-width: 100px;
            padding: 6px 15px;
            margin:    5px 0px 5px 0px;

            &.no-fill{
                background-color: white;
                box-shadow: none;
                color: #dc143d;
                border: 1px solid #dc143d;
                padding: 5px 14px;
                margin: 5px 0px 5px 40px;

                &:hover{
                    color: #212146;
                    border: 1px solid #212146;
                }
            }
        }
        .vs_dropdown-menu {
            height: 110px;
        }
        .date-field{
			width: 100%;
			display: inline-block;
			margin: auto auto 5px auto;
			input{
			    width: 80%;
			    padding: 0 0 5px;
			    border-radius: 4px;
                display: inline-block;
                border: 1px solid #BDBDBD;
                box-sizing: border-box;
			}
		}
		
		.horizontal-separator{
		    background-color: #f0f0f0;
		    width: 150%;
		    margin-left: 0px;
		    padding-left: 0px;
		}
		
		#firstSection{
		    margin: 0px 40px 0px 40px;
		}
		
		#secondSection{
		    margin: 0px 40px 0px 40px;
		    
		}
    }
    .footer {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
    }
    .checkbox-alert {
        display: flex;
        align-items: center;
        padding-left: 15px;
    }
</style>